import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyle, SiteWrapper } from "./src/theme/Site.style";
import theme from "./src/theme";
import PropTypes from "prop-types";

const Wrapper = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <SiteWrapper>{element}</SiteWrapper>
    </ThemeProvider>
  );
};

Wrapper.propTypes = {
  element: PropTypes.node
};
export default Wrapper;
